import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LogQueryEditForm } from "./components/LogQueryEditForm";

export function EditLogQueryPage() {
  return (
    <Page title="Edit Query">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogQueryEditForm />
      </Container>
    </Page>
  );
}
